import { AApi } from './AApi';
import type { ApiResult } from '../types/api.types';
import type { TextDiffBody } from '../types/diff.types';
import type { PlainTextBody, PlainTextInput } from '../types/helpers.types';

/** The small tools: `/helpers`. */
export class HelpersApi extends AApi {
    public createDiff(from: string, to: string): Promise<ApiResult<TextDiffBody>> {
        return this.Client.post(`${this.VersionPath}/helpers/diff`, { from, to });
    }

    public cleanPlainText(input: PlainTextInput): Promise<ApiResult<PlainTextBody>> {
        return this.Client.post(`${this.VersionPath}/helpers/plainText`, input);
    }
}
